/* tslint:disable */
/* eslint-disable */
/**
 * B2B Ground
 * Ground API  # Tracking Metrics * `b2bportal.availability.failure`   * tags: `api_version`, `error_code`, `product`, `tenantid` * `b2bportal.availability.success`   * tags: `api_version`, `product`, `tenantid` * `b2bportal.availability.volume`   * tags: `api_version`, `product`, `tenantid` * `b2bportal.booking.product.error`   * tags: `api_version`, `error_code`, `product`, `tenantid` * `b2bportal.cancel.failure`   * tags: `api_version`, `cancel_scenario`, `error_code`, `product`, `tenantid` * `b2bportal.cancel.success`   * tags: `api_version`, `cancel_scenario`, `product`, `tenantid` * `b2bportal.ground.autoComplete.failure`   * tags: `api_version`, `error_code`, `tenantid` * `b2bportal.ground.autoComplete.success`   * tags: `api_version`, `tenantid` * `b2bportal.ground.shop.failure`   * tags: `api_version`, `error_code`, `tenantid` * `b2bportal.ground.shop.success`   * tags: `api_version`, `tenantid` * `b2bportal.ground.singleItinerary.failure`   * tags: `api_version`, `error_code`, `tenantid` * `b2bportal.ground.singleItinerary.success`   * tags: `api_version`, `tenantid` * `b2bportal.mytrips.get.failure`   * tags: `api_version`, `error_code`, `product`, `tenantid` * `b2bportal.mytrips.get.success`   * tags: `api_version`, `product`, `tenantid` * `b2bportal.quote.cancel.product.failure`   * tags: `api_version`, `cancel_scenario`, `error_code`, `product`, `tenantid` * `b2bportal.quote.cancel.product.success`   * tags: `api_version`, `cancel_scenario`, `product`, `tenantid` * `b2bportal.quote.product.error`   * tags: `api_version`, `error_code`, `product`, `quote_action`, `tenantid`   # Tracking Error Codes * `advance_lead_time` * `age_requirement` * `bad_request` * `duplicate_booking` * `internal_error` * `invalid_loyalty_number` * `overlapping_reservation` * `price_change` * `rate_unavailable` * `request_deserialization_error` * `response_serialization_error` * `rewards_not_found` * `unknown`  # Tracking Error Codes * `bad_request` * `internal_cancel_error$` * `product_failure` * `refund_failure` * `request_deserialization_cancel_error$` * `response_serialization_error` * `schedule_failure` * `unknown`  # Cancel Scenarios * `canceled` * `contact_customer_service` * `fully_refundable` * `non_refundable` * `pending`  
 *
 * The version of the OpenAPI document: v1p1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface AccountPrice {
    'currency': string;
    'value': number;
    'currencyDescription'?: string;
}
export interface AdvanceLeadTime {
    'hoursBeforePickup'?: number;
    'GroundError': GroundErrorEnum;
}


export interface AgeRequirement {
    'age'?: number;
    'ageRequirement'?: AgeRequirementType;
    'GroundError': GroundErrorEnum;
}


export const AgeRequirementType = {
    MaxAge: 'MaxAge',
    MinAge: 'MinAge'
} as const;

export type AgeRequirementType = typeof AgeRequirementType[keyof typeof AgeRequirementType];


/**
 * When regionType is airport, code represents an IATA airport code and when regionType is city, code is an IATA city code
 * @export
 * @interface AirportRegion
 */
export interface AirportRegion {
    'regionType': RegionType;
    'code': string;
}


/**
 * A monetary amount
 * @export
 * @interface Amount
 */
export interface Amount {
    'amount': number;
    'currency': string;
}
export interface AppGroundSelection {
    'code': string;
    'CodeContext': CodeContextEnum;
}


/**
 * Category of the autocomplete suggestions
 * @export
 * @enum {string}
 */

export const AutocompleteCategory = {
    airports: 'airports',
    cities: 'cities',
    emptyMatch: 'emptyMatch',
    featuredGetaways: 'featuredGetaways',
    hotelMarkets: 'hotelMarkets',
    nearby: 'nearby',
    places: 'places',
    recentSearches: 'recentSearches'
} as const;

export type AutocompleteCategory = typeof AutocompleteCategory[keyof typeof AutocompleteCategory];


/**
 * @type AvailabilityFilter
 * Optional filter to apply to the availability search.
 * @export
 */
export type AvailabilityFilter = { AvailabilityFilter: 'VendorExclusionFilter' } & VendorExclusionFilter;

export const AvailabilityFilterEnum = {
    VendorExclusionFilter: 'VendorExclusionFilter'
} as const;

export type AvailabilityFilterEnum = typeof AvailabilityFilterEnum[keyof typeof AvailabilityFilterEnum];


/**
 * Represents a request for ground availability.

 * `driverAge` - The age of the driver.
 * `dropOffTime` - The local date and time for the drop-off.
 * `dropOffSelection` - The context code for the drop-off location.
 * `pickupTime` - The local date and time for the pickup.
 * `filter` - Optional filter to apply to the availability search.
 * `pickupSelection` - The context code for the pickup location.
 * @export
 * @interface AvailabilityRequest
 */
export interface AvailabilityRequest {
    /**
     * The age of the driver.
     * @type {number}
     * @memberof AvailabilityRequest
     */
    'driverAge': number;
    /**
     * The local date and time for the drop-off.
     * @type {string}
     * @memberof AvailabilityRequest
     */
    'dropOffTime': string;
    'dropOffSelection': CodeContext;
    /**
     * The local date and time for the pickup.
     * @type {string}
     * @memberof AvailabilityRequest
     */
    'pickupTime': string;
    'filter'?: AvailabilityFilter;
    'pickupSelection': CodeContext;
}
/**
 * Represents the response for an availability request.

 * `pickUpLocationCountry` - Optional country of the pickup location.
 * `context` - Contextual information for the availability results.
 * `vehicles` - List of available vehicles.
 * `searchCoordinates` - The geographical coordinates used for the search.
 * `bestOfferOverall` - Optional best offer available overall.
 * @export
 * @interface AvailabilityResponse
 */
export interface AvailabilityResponse {
    /**
     * Optional country of the pickup location.
     * @type {string}
     * @memberof AvailabilityResponse
     */
    'pickUpLocationCountry'?: string;
    'context': ResultsContext;
    /**
     * List of available vehicles.
     * @type {Array<VehicleAvailability>}
     * @memberof AvailabilityResponse
     */
    'vehicles': Array<VehicleAvailability>;
    'searchCoordinates': Coordinates;
    'bestOfferOverall'?: TravelWalletOffer;
}
export interface BoundingBox {
    'northEast': Coordinates;
    'southWest': Coordinates;
    'LocationDescriptor': LocationDescriptorEnum;
}


export interface BoundingCircle {
    'center': Coordinates;
    'radius': number;
    'LocationDescriptor': LocationDescriptorEnum;
}


/**
 * `triggeredBy` - The trigger of the cancellation
 * @export
 * @interface CancelInformation
 */
export interface CancelInformation {
    'cancelId': string;
    'cancelDate': string;
    /**
     * The trigger of the cancellation
     * @type {string}
     * @memberof CancelInformation
     */
    'triggeredBy'?: string;
}
/**
 * policy result for ground already in a canceled status
 * @export
 * @interface Canceled
 */
export interface Canceled {
    'GroundCancelScenario': GroundCancelScenarioEnum;
}


export interface CancellationPolicy {
    'free': boolean;
    'desc': string;
}
/**
 * `category` - Category of the autocomplete suggestions
 * `label` - Label for the category
 * `results` - List of autocomplete suggestions
 * @export
 * @interface CategorizedResponse
 */
export interface CategorizedResponse {
    'category': AutocompleteCategory;
    /**
     * Label for the category
     * @type {string}
     * @memberof CategorizedResponse
     */
    'label': string;
    /**
     * List of autocomplete suggestions
     * @type {Array<Suggestion>}
     * @memberof CategorizedResponse
     */
    'results': Array<Suggestion>;
}


/**
 * `kind` - The type of charge related to the ancillary, such as daily price or total price
 * `amount` - The amount of the charge
 * @export
 * @interface Charge
 */
export interface Charge {
    'kind': ChargeKind;
    'amount': Prices;
}


/**
 * 

* `Extra` - Additional charge for the ancillary
* `ExtraCDW` - Collision Damage Waiver charge
* `ExtraDaily` - Daily price for the ancillary
* `ExtraOriginal` - Original price for the ancillary
* `ExtraSLI` - Supplemental Liability Insurance charge
* `TotalWithExtra` - Total price including the ancillary
 * @export
 * @enum {string}
 */

export const ChargeKind = {
    Extra: 'Extra',
    ExtraCDW: 'ExtraCDW',
    ExtraDaily: 'ExtraDaily',
    ExtraOriginal: 'ExtraOriginal',
    ExtraSLI: 'ExtraSLI',
    TotalWithExtra: 'TotalWithExtra'
} as const;

export type ChargeKind = typeof ChargeKind[keyof typeof ChargeKind];


export interface City {
    'city': string;
    'country': string;
    'CodeContext': CodeContextEnum;
}


/**
 * @type CodeContext
 * The context code for the drop-off location.
 * @export
 */
export type CodeContext = { CodeContext: 'AppGroundSelection' } & AppGroundSelection | { CodeContext: 'City' } & City | { CodeContext: 'Gcs' } & Gcs | { CodeContext: 'GooglePlace' } & GooglePlace | { CodeContext: 'GroundBoundingBox' } & GroundBoundingBox | { CodeContext: 'Iata' } & Iata | { CodeContext: 'Location' } & Location;

export const CodeContextEnum = {
    AppGroundSelection: 'AppGroundSelection',
    City: 'City',
    Gcs: 'Gcs',
    GooglePlace: 'GooglePlace',
    GroundBoundingBox: 'GroundBoundingBox',
    Iata: 'Iata',
    Location: 'Location'
} as const;

export type CodeContextEnum = typeof CodeContextEnum[keyof typeof CodeContextEnum];


/**
 * `providerBookingId` - The provider's booking identifier
 * `supplierBookingId` - The supplier's booking identifier. Is None for direct bookings
 * @export
 * @interface ConfirmationInfo
 */
export interface ConfirmationInfo {
    /**
     * The provider's booking identifier
     * @type {string}
     * @memberof ConfirmationInfo
     */
    'providerBookingId': string;
    /**
     * The supplier's booking identifier. Is None for direct bookings
     * @type {string}
     * @memberof ConfirmationInfo
     */
    'supplierBookingId'?: string;
}
/**
 * policy result for hotel that needs Customer Service action to be canceled
 * @export
 * @interface ContactCustomerService
 */
export interface ContactCustomerService {
    'customerServiceCopy': Copy;
    'GroundCancelScenario': GroundCancelScenarioEnum;
}


export interface Coordinate {
    'lat': number;
    'lon': number;
    'LocationQuery': LocationQueryEnum;
}


export interface Coordinates {
    'lat': number;
    'lon': number;
}
/**
 * Message that will inform the user of the financial result of a ground cancellation.
 * @export
 * @interface Copy
 */
export interface Copy {
    'importantInfo': Array<string>;
    'body': Array<string>;
    'informativeSection'?: InformativeSection;
    'disclaimer'?: string;
    'title': string;
}
export interface CorporateTravel {
    'policyCompliance': PolicyCompliance;
}
/**
 * @type DistKind
 * @export
 */
export type DistKind = { DistKind: 'Limited' } & Limited | { DistKind: 'Unlimited' } & Unlimited;

export const DistKindEnum = {
    Limited: 'Limited',
    Unlimited: 'Unlimited'
} as const;

export type DistKindEnum = typeof DistKindEnum[keyof typeof DistKindEnum];


export const DistanceUnit = {
    Km: 'Km',
    Mi: 'Mi'
} as const;

export type DistanceUnit = typeof DistanceUnit[keyof typeof DistanceUnit];


/**
 * Type of drive - two wheel or four wheel
 * @export
 * @enum {string}
 */

export const DriveType = {
    FourWheelDrive: 'FourWheelDrive',
    TwoWheelDrive: 'TwoWheelDrive',
    Unavailable: 'Unavailable'
} as const;

export type DriveType = typeof DriveType[keyof typeof DriveType];


export interface DriverLicense {
    'country': string;
    'cityCode': string;
    'street': string;
    'postCode': string;
}
export interface DuplicateBooking {
    'GroundError': GroundErrorEnum;
}


export interface Empty {
    'LocationQuery': LocationQueryEnum;
}


export interface Extensions {
    'distance': DistKind;
    'cancellation': CancellationPolicy;
    'fuelPolicy'?: FuelPolicy;
}
export interface ExtraInfoAmount {
    'total': FiatPrice;
}
/**
 * Cancellation failed to process fulfillment
 * @export
 * @interface Failure
 */
export interface Failure {
    'GroundCancelFulfillPollResponse': GroundCancelFulfillPollResponseEnum;
    'Aborted': GroundCancelFulfillPollResponseAbortedEnum;
}


export interface FeesSummary {
    'total': FiatPrice;
}
/**
 * A cash amount
 * @export
 * @interface FiatPrice
 */
export interface FiatPrice {
    'currencyCode': string;
    'currencySymbol': string;
    'value': number;
}
/**
 * `code` - Airport region code
 * @export
 * @interface Flight
 */
export interface Flight {
    'code': AirportRegion;
    'Id': PlaceIdEnum;
}


export interface FuelPolicy {
    'kind': FuelPolicyKind;
    'desc': string;
}


export const FuelPolicyKind = {
    FreeTank: 'FreeTank',
    FullToFull: 'FullToFull',
    MultipleOptionsAtDesk: 'MultipleOptionsAtDesk',
    PrepayNoRefunds: 'PrepayNoRefunds',
    PrepayRefunds: 'PrepayRefunds',
    ReturnSame: 'ReturnSame',
    Unknown: 'Unknown'
} as const;

export type FuelPolicyKind = typeof FuelPolicyKind[keyof typeof FuelPolicyKind];


/**
 * The type of fuel used by the vehicle
 * @export
 * @enum {string}
 */

export const FuelType = {
    CNG: 'CNG',
    Diesel: 'Diesel',
    Electric: 'Electric',
    Ethanol: 'Ethanol',
    Gasoline: 'Gasoline',
    Hybrid: 'Hybrid',
    Hydrogen: 'Hydrogen',
    LPG: 'LPG',
    MultiFuel: 'MultiFuel',
    Unspecified: 'Unspecified'
} as const;

export type FuelType = typeof FuelType[keyof typeof FuelType];


/**
 * policy result for hotel cancellation that results in a full refund
 * @export
 * @interface FullyRefundable
 */
export interface FullyRefundable {
    'cancelCopy': Copy;
    'cancelConfirmationCopy': Copy;
    'GroundCancelScenario': GroundCancelScenarioEnum;
}


export const Funnel = {
    Air: 'Air',
    Ground: 'Ground',
    Home: 'Home',
    Lodging: 'Lodging'
} as const;

export type Funnel = typeof Funnel[keyof typeof Funnel];


export interface Gcs {
    'coordinates': Coordinates;
    'label'?: string;
    'CodeContext': CodeContextEnum;
}


export interface GooglePlace {
    'code': string;
    'name'?: string;
    'CodeContext': CodeContextEnum;
}


/**
 * The ground booking result

 * `bookingId` - User facing ground booking confirmation code
 * `groundBookingId` - Internal ground booking identifier
 * @export
 * @interface GroundBookingResult
 */
export interface GroundBookingResult {
    'cancellationRules'?: RestrictionCancel;
    'vehicle': Vehicle;
    /**
     * User facing ground booking confirmation code
     * @type {string}
     * @memberof GroundBookingResult
     */
    'bookingId'?: string;
    'vendorMessages'?: VendorMessages;
    'supplier': GroundSupplier;
    /**
     * Internal ground booking identifier
     * @type {string}
     * @memberof GroundBookingResult
     */
    'groundBookingId': string;
    'trackingPropertiesV2': TrackingProperties;
    'confirmationInfo'?: ConfirmationInfo;
    'pickUp': LocationBookDateTime;
    'dropOff': LocationBookDateTime;
    'vendor': GroundVendor;
    'rentalRate': RentalRate;
}
export interface GroundBoundingBox {
    'northEast': Coordinates;
    'southWest': Coordinates;
    'CodeContext': CodeContextEnum;
}


/**
 * Request for the status of the fulfillment session in progress. This is an idempotent call and just fetches the state of the session.

 * `fulfillmentSessionId` - Encrypted fulfillment session id.
 * @export
 * @interface GroundCancelFulfillPollRequest
 */
export interface GroundCancelFulfillPollRequest {
    /**
     * Encrypted fulfillment session id.
     * @type {string}
     * @memberof GroundCancelFulfillPollRequest
     */
    'fulfillmentSessionId': string;
}
/**
 * @type GroundCancelFulfillPollResponse
 * Fulfillment session status. Can be Pending, Success or Failure.
 * @export
 */
export type GroundCancelFulfillPollResponse = { GroundCancelFulfillPollResponse: 'Aborted' } & GroundCancelFulfillPollResponseAborted | { GroundCancelFulfillPollResponse: 'Pending' } & GroundCancelFulfillPollResponsePending | { GroundCancelFulfillPollResponse: 'Success' } & GroundCancelFulfillPollResponseSuccess;

/**
 * @type GroundCancelFulfillPollResponseAborted
 * @export
 */
export type GroundCancelFulfillPollResponseAborted = { Aborted: 'Failure' } & Failure | { Aborted: 'ProductFailure' } & ProductFailure | { Aborted: 'RefundFailure' } & RefundFailure | { Aborted: 'UnknownFailure' } & UnknownFailure;

export const GroundCancelFulfillPollResponseAbortedEnum = {
    Failure: 'Failure',
    ProductFailure: 'ProductFailure',
    RefundFailure: 'RefundFailure',
    UnknownFailure: 'UnknownFailure'
} as const;

export type GroundCancelFulfillPollResponseAbortedEnum = typeof GroundCancelFulfillPollResponseAbortedEnum[keyof typeof GroundCancelFulfillPollResponseAbortedEnum];


export const GroundCancelFulfillPollResponseEnum = {
    Aborted: 'Aborted',
    Pending: 'Pending',
    Success: 'Success'
} as const;

export type GroundCancelFulfillPollResponseEnum = typeof GroundCancelFulfillPollResponseEnum[keyof typeof GroundCancelFulfillPollResponseEnum];


/**
 * Cancellation fulfillment is still in progress
 * @export
 * @interface GroundCancelFulfillPollResponsePending
 */
export interface GroundCancelFulfillPollResponsePending {
    'GroundCancelFulfillPollResponse': GroundCancelFulfillPollResponseEnum;
}


/**
 * Cancellation fulfillment succeeded
 * @export
 * @interface GroundCancelFulfillPollResponseSuccess
 */
export interface GroundCancelFulfillPollResponseSuccess {
    'GroundCancelFulfillPollResponse': GroundCancelFulfillPollResponseEnum;
}


/**
 * Request that starts the fulfillment of a ground cancel. It creates state by starting a cart fulfillment session.

 * `quoteSessionId` - Encrypted quote session id to perform fulfillment.
 * @export
 * @interface GroundCancelFulfillScheduleRequest
 */
export interface GroundCancelFulfillScheduleRequest {
    /**
     * Encrypted quote session id to perform fulfillment.
     * @type {string}
     * @memberof GroundCancelFulfillScheduleRequest
     */
    'quoteSessionId': string;
}
/**
 * @type GroundCancelFulfillScheduleResponse
 * @export
 */
export type GroundCancelFulfillScheduleResponse = { GroundCancelFulfillScheduleResponse: 'Failure' } & GroundCancelFulfillScheduleResponseFailure | { GroundCancelFulfillScheduleResponse: 'Success' } & GroundCancelFulfillScheduleResponseSuccess;

export const GroundCancelFulfillScheduleResponseEnum = {
    Failure: 'Failure',
    Success: 'Success'
} as const;

export type GroundCancelFulfillScheduleResponseEnum = typeof GroundCancelFulfillScheduleResponseEnum[keyof typeof GroundCancelFulfillScheduleResponseEnum];


/**
 * Failed response to a fulfillment request.
 * @export
 * @interface GroundCancelFulfillScheduleResponseFailure
 */
export interface GroundCancelFulfillScheduleResponseFailure {
    'GroundCancelFulfillScheduleResponse': GroundCancelFulfillScheduleResponseEnum;
}


/**
 * Response to a fulfillment request. Contains the identifier used to poll the status of the fulfillment session.

 * `fulfillmentSessionId` - Encrypted fulfillment session id. Used in the GroundCancelFulfillmentPollRequest to poll the status of the fulfillment.
 * @export
 * @interface GroundCancelFulfillScheduleResponseSuccess
 */
export interface GroundCancelFulfillScheduleResponseSuccess {
    /**
     * Encrypted fulfillment session id. Used in the GroundCancelFulfillmentPollRequest to poll the status of the fulfillment.
     * @type {string}
     * @memberof GroundCancelFulfillScheduleResponseSuccess
     */
    'fulfillmentSessionId': string;
    'GroundCancelFulfillScheduleResponse': GroundCancelFulfillScheduleResponseEnum;
}


/**
 * Request for the status of the fulfillment session in progress. This is an idempotent call and just fetches the state of the session.

 * `quoteSessionId` - Encrypted quote session id.
 * @export
 * @interface GroundCancelQuotePollRequest
 */
export interface GroundCancelQuotePollRequest {
    /**
     * Encrypted quote session id.
     * @type {string}
     * @memberof GroundCancelQuotePollRequest
     */
    'quoteSessionId': string;
}
/**
 * @type GroundCancelQuotePollResponse
 * Quote session status. Can be Pending, Success or Failure.
 * @export
 */
export type GroundCancelQuotePollResponse = { GroundCancelQuotePollResponse: 'Failure' } & GroundCancelQuotePollResponseFailure | { GroundCancelQuotePollResponse: 'Pending' } & GroundCancelQuotePollResponsePending | { GroundCancelQuotePollResponse: 'Success' } & GroundCancelQuotePollResponseSuccess;

export const GroundCancelQuotePollResponseEnum = {
    Failure: 'Failure',
    Pending: 'Pending',
    Success: 'Success'
} as const;

export type GroundCancelQuotePollResponseEnum = typeof GroundCancelQuotePollResponseEnum[keyof typeof GroundCancelQuotePollResponseEnum];


/**
 * Cancellation quote failed
 * @export
 * @interface GroundCancelQuotePollResponseFailure
 */
export interface GroundCancelQuotePollResponseFailure {
    'GroundCancelQuotePollResponse': GroundCancelQuotePollResponseEnum;
}


/**
 * Cancellation quote is still in progress
 * @export
 * @interface GroundCancelQuotePollResponsePending
 */
export interface GroundCancelQuotePollResponsePending {
    'GroundCancelQuotePollResponse': GroundCancelQuotePollResponseEnum;
}


/**
 * Cancellation quote succeeded

 * `cancelScenario` - Policy that would result for this ground if cancellation proceeds.
 * @export
 * @interface GroundCancelQuotePollResponseSuccess
 */
export interface GroundCancelQuotePollResponseSuccess {
    'cancelScenario': GroundCancelScenario;
    'GroundCancelQuotePollResponse': GroundCancelQuotePollResponseEnum;
}


/**
 * Request that start a Ground Cancel Quote. This is an idempotent request.

 * `reservationId` - Unique reservation id that identifies the ground.
 * @export
 * @interface GroundCancelQuoteScheduleRequest
 */
export interface GroundCancelQuoteScheduleRequest {
    /**
     * The unique identifier for the ground reservation.
     * @type {string}
     * @memberof GroundCancelQuoteScheduleRequest
     */
    'reservationId': string;
}
/**
 * @type GroundCancelQuoteScheduleResponse
 * @export
 */
export type GroundCancelQuoteScheduleResponse = { GroundCancelQuoteScheduleResponse: 'Failure' } & GroundCancelQuoteScheduleResponseFailure | { GroundCancelQuoteScheduleResponse: 'Success' } & GroundCancelQuoteScheduleResponseSuccess;

export const GroundCancelQuoteScheduleResponseEnum = {
    Failure: 'Failure',
    Success: 'Success'
} as const;

export type GroundCancelQuoteScheduleResponseEnum = typeof GroundCancelQuoteScheduleResponseEnum[keyof typeof GroundCancelQuoteScheduleResponseEnum];


/**
 * Failed Ground cancel quote response
 * @export
 * @interface GroundCancelQuoteScheduleResponseFailure
 */
export interface GroundCancelQuoteScheduleResponseFailure {
    'GroundCancelQuoteScheduleResponse': GroundCancelQuoteScheduleResponseEnum;
}


/**
 * Cancel quote response with the fare rule result and quote identifier.

 * `quoteSessionId` - The encrypted quote identifier, used for poll the quote result and in GroundCancelFulfillRequest to fulfill the cancellation.
 * @export
 * @interface GroundCancelQuoteScheduleResponseSuccess
 */
export interface GroundCancelQuoteScheduleResponseSuccess {
    /**
     * The encrypted quote identifier, used for poll the quote result and in GroundCancelFulfillRequest to fulfill the cancellation.
     * @type {string}
     * @memberof GroundCancelQuoteScheduleResponseSuccess
     */
    'quoteSessionId': string;
    'GroundCancelQuoteScheduleResponse': GroundCancelQuoteScheduleResponseEnum;
}


/**
 * @type GroundCancelScenario
 * response to ground cancellation and change policy requests
 * @export
 */
export type GroundCancelScenario = { GroundCancelScenario: 'Canceled' } & Canceled | { GroundCancelScenario: 'ContactCustomerService' } & ContactCustomerService | { GroundCancelScenario: 'FullyRefundable' } & FullyRefundable | { GroundCancelScenario: 'NonRefundable' } & NonRefundable | { GroundCancelScenario: 'Pending' } & Pending;

export const GroundCancelScenarioEnum = {
    Canceled: 'Canceled',
    ContactCustomerService: 'ContactCustomerService',
    FullyRefundable: 'FullyRefundable',
    NonRefundable: 'NonRefundable',
    Pending: 'Pending'
} as const;

export type GroundCancelScenarioEnum = typeof GroundCancelScenarioEnum[keyof typeof GroundCancelScenarioEnum];


/**
 * @type GroundError
 * Ground product errors for quote and booking
 * @export
 */
export type GroundError = { GroundError: 'AdvanceLeadTime' } & AdvanceLeadTime | { GroundError: 'AgeRequirement' } & AgeRequirement | { GroundError: 'DuplicateBooking' } & DuplicateBooking | { GroundError: 'InvalidLoyaltyNumber' } & InvalidLoyaltyNumber | { GroundError: 'OverlappingReservation' } & OverlappingReservation | { GroundError: 'PriceChange' } & PriceChange | { GroundError: 'RateUnavailable' } & RateUnavailable | { GroundError: 'RewardsNotFound' } & RewardsNotFound | { GroundError: 'Unknown' } & Unknown;

export const GroundErrorEnum = {
    AdvanceLeadTime: 'AdvanceLeadTime',
    AgeRequirement: 'AgeRequirement',
    DuplicateBooking: 'DuplicateBooking',
    InvalidLoyaltyNumber: 'InvalidLoyaltyNumber',
    OverlappingReservation: 'OverlappingReservation',
    PriceChange: 'PriceChange',
    RateUnavailable: 'RateUnavailable',
    RewardsNotFound: 'RewardsNotFound',
    Unknown: 'Unknown'
} as const;

export type GroundErrorEnum = typeof GroundErrorEnum[keyof typeof GroundErrorEnum];


/**
 * The ground price quote
 * @export
 * @interface GroundPriceQuote
 */
export interface GroundPriceQuote {
    'vehAvail': VehicleAvail;
    'trackingPropertiesV2': TrackingProperties;
}
/**
 * Request a ground quote

 * `loyaltyRewardsNumbers` - loyalty rewards numbers
 * `emailAddress` - Deprecated. Only exists for capone purchase v0 compatibility. Remove once they are on v1.
 * `vehicleId` - The vehicle id. optional for capone backwards compatibility. Make required once they are completely on cart
 * `opaquePriceRequest` - Deprecated in shopping cart.The opaque version of the `PriceRQ` model found on the `opaqueBookRequest` field of the shop response. Remove once they are completely on cart
 * `driverId` - The person id of the driver with DriversLicence and age validated already
 * @export
 * @interface GroundPriceQuoteScheduleRequest
 */
export interface GroundPriceQuoteScheduleRequest {
    'loyaltyRewardsNumbers'?: LoyaltyRewardsNumbers;
    /**
     * A phone Number. The frontend should validate the phone number since the request will fail if it doesn't match the pattern
     * @type {string}
     * @memberof GroundPriceQuoteScheduleRequest
     */
    'phoneNumber': string;
    /**
     * An email address that matches given regex pattern. The frontend should validate the emails address since the request will fail if it doesn't match the pattern
     * @type {string}
     * @memberof GroundPriceQuoteScheduleRequest
     */
    'emailAddress'?: string;
    /**
     * The vehicle id. optional for capone backwards compatibility. Make required once they are completely on cart
     * @type {string}
     * @memberof GroundPriceQuoteScheduleRequest
     */
    'vehicleId'?: string;
    /**
     * Deprecated in shopping cart.The opaque version of the `PriceRQ` model found on the `opaqueBookRequest` field of the shop response. Remove once they are completely on cart
     * @type {string}
     * @memberof GroundPriceQuoteScheduleRequest
     */
    'opaquePriceRequest': string;
    /**
     * The person id of the driver with DriversLicence and age validated already
     * @type {string}
     * @memberof GroundPriceQuoteScheduleRequest
     */
    'driverId': string;
}
/**
 * Autocomplete for ground query

 * `query` - Query by name or coordinates
 * `sessionToken` - Optional session token for the query
 * @export
 * @interface GroundQuery
 */
export interface GroundQuery {
    'query': LocationQuery;
    /**
     * Optional session token for the query
     * @type {string}
     * @memberof GroundQuery
     */
    'sessionToken'?: string;
}
export interface GroundReservationStateCancelled {
    'reason'?: ReservationStateReason;
    'cancelInformation': CancelInformation;
    'ReservationState': ReservationStateEnum;
}


export interface GroundReservationStateConfirmed {
    'reason'?: ReservationStateReason;
    'ReservationState': ReservationStateEnum;
}


export interface GroundReservationStateFailure {
    'reason': ReservationStateReason;
    'ReservationState': ReservationStateEnum;
}


export interface GroundReservationStatePending {
    'reason'?: ReservationStateReason;
    'ReservationState': ReservationStateEnum;
}


/**
 * Autocomplete suggestions

 * `categories` - List of autocomplete suggestions by category
 * @export
 * @interface GroundResponse
 */
export interface GroundResponse {
    /**
     * List of autocomplete suggestions by category
     * @type {Array<CategorizedResponse>}
     * @memberof GroundResponse
     */
    'categories': Array<CategorizedResponse>;
}
/**
 * @type GroundSelection
 * Ground selection details
 * @export
 */
export type GroundSelection = { GroundSelection: 'Location' } & Location | { GroundSelection: 'Place' } & Place;

export const GroundSelectionEnum = {
    Location: 'Location',
    Place: 'Place'
} as const;

export type GroundSelectionEnum = typeof GroundSelectionEnum[keyof typeof GroundSelectionEnum];


export interface GroundSupplier {
    'code': string;
    'name': string;
    'logo': string;
    'contactSupport'?: string;
}
export interface GroundVendor {
    'code': string;
    'name': string;
    'contactSupport'?: string;
}
/**
 * `groundSelection` - Ground selection details
 * @export
 * @interface Grounds
 */
export interface Grounds {
    'groundSelection': GroundSelection;
    'Id': PlaceIdEnum;
}


export interface Iata {
    'coordinates'?: Coordinates;
    'city'?: string;
    'CodeContext': CodeContextEnum;
    'country'?: string;
    'code': string;
}


/**
 * Informative section attached to the end of the modal, informs the user of details about the cancellation.
 * @export
 * @interface InformativeSection
 */
export interface InformativeSection {
    'title': string;
    'body': Array<string>;
}
export interface InvalidLoyaltyNumber {
    'GroundError': GroundErrorEnum;
}


/**
 * Request for fetching itineraries from login user

 * `states` - Target states of itineraries
 * `referenceDateTime` - Reference date time for filtering itineraries
 * @export
 * @interface ItinerariesRequest
 */
export interface ItinerariesRequest {
    /**
     * Target states of itineraries
     * @type {Array<ItineraryState>}
     * @memberof ItinerariesRequest
     */
    'states': Array<ItineraryState>;
    /**
     * Reference date time for filtering itineraries
     * @type {string}
     * @memberof ItinerariesRequest
     */
    'referenceDateTime': string;
}
export interface ItinerariesResponse {
    'itinerariesByState': { [key: string]: Array<Itinerary>; };
}
/**
 * The information of the itinerary that contains the ground booking information and payment information

 * `reservation` - Ground reservation summary
 * `paymentBreakdown` - Breakdown of all the payments used for purchase
 * `paymentTotal` - Sum of all payments in PaymentBreakdown
 * @export
 * @interface Itinerary
 */
export interface Itinerary {
    'reservation': Reservation;
    'paymentBreakdown'?: PaymentBreakdown;
    'paymentTotal'?: Prices;
}
export const ItineraryState = {
    Canceled: 'Canceled',
    Future: 'Future',
    Invalid: 'Invalid',
    Past: 'Past',
    Present: 'Present'
} as const;

export type ItineraryState = typeof ItineraryState[keyof typeof ItineraryState];


export interface Label {
    'l': string;
    'LocationQuery': LocationQueryEnum;
}


export interface Limited {
    'qty'?: number;
    'distUnit'?: DistanceUnit;
    'DistKind': DistKindEnum;
}


export interface Link {
    'kind': LinkKind;
    'link': string;
}


export const LinkKind = {
    PostBookingCertificateURI: 'PostBookingCertificateURI',
    PostBookingDIPDanniCertificate: 'PostBookingDIPDanniCertificate',
    PostBookingKeyFactsURI: 'PostBookingKeyFactsURI',
    PostBookingPolicyWordingURI: 'PostBookingPolicyWordingURI',
    PreBookingDIPDanniCertificate: 'PreBookingDIPDanniCertificate',
    PreBookingKeyFactsURI: 'PreBookingKeyFactsURI',
    PreBookingPolicyWordingURI: 'PreBookingPolicyWordingURI'
} as const;

export type LinkKind = typeof LinkKind[keyof typeof LinkKind];


export interface Location {
    'coordinates': Coordinates;
    'city': string;
    'name': string;
    'CodeContext': CodeContextEnum;
    'country': string;
}


/**
 * `dateTime` - time in the timezone of the location
 * @export
 * @interface LocationBookDateTime
 */
export interface LocationBookDateTime {
    /**
     * time in the timezone of the location
     * @type {string}
     * @memberof LocationBookDateTime
     */
    'dateTime': string;
    'location': ResponseLocation;
}
/**
 * `dateTime` - time in the timezone of the location
 * @export
 * @interface LocationDateTimeRef
 */
export interface LocationDateTimeRef {
    /**
     * time in the timezone of the location
     * @type {string}
     * @memberof LocationDateTimeRef
     */
    'dateTime': string;
}
/**
 * @type LocationDescriptor
 * Descriptor for the location
 * @export
 */
export type LocationDescriptor = { LocationDescriptor: 'BoundingBox' } & BoundingBox | { LocationDescriptor: 'BoundingCircle' } & BoundingCircle;

export const LocationDescriptorEnum = {
    BoundingBox: 'BoundingBox',
    BoundingCircle: 'BoundingCircle'
} as const;

export type LocationDescriptorEnum = typeof LocationDescriptorEnum[keyof typeof LocationDescriptorEnum];


/**
 * @type LocationQuery
 * Query by name or coordinates
 * @export
 */
export type LocationQuery = { LocationQuery: 'Coordinate' } & Coordinate | { LocationQuery: 'Empty' } & Empty | { LocationQuery: 'Label' } & Label;

export const LocationQueryEnum = {
    Coordinate: 'Coordinate',
    Empty: 'Empty',
    Label: 'Label'
} as const;

export type LocationQueryEnum = typeof LocationQueryEnum[keyof typeof LocationQueryEnum];


/**
 * loyalty rewards numbers

 * `hertz` - The hertz loyalty rewards number
 * @export
 * @interface LoyaltyRewardsNumbers
 */
export interface LoyaltyRewardsNumbers {
    /**
     * The hertz loyalty rewards number
     * @type {string}
     * @memberof LoyaltyRewardsNumbers
     */
    'hertz'?: string;
}
export interface Markup {
    'amount': Amount;
}
/**
 * policy result for hotel cancellation that is non-refundable
 * @export
 * @interface NonRefundable
 */
export interface NonRefundable {
    'cancelCopy': Copy;
    'GroundCancelScenario': GroundCancelScenarioEnum;
}


export interface OverlappingReservation {
    'GroundError': GroundErrorEnum;
}


/**
 * `Payment` types require shared, known types between client and server. `OpaqueValue`
is used to serialize and deserialize models related to specific `Payment`, but avoid coupling
this purchase interface to the specific `Payment` implementation.

### Attributes
 * `PaymentModel.Create` **required**
 *    Request model used to add the payment to an order during checkout.
 * `PaymentModel.Authorize` **optional**
 *    Request model used to fulfill a payment challenge during the 

 * PaymentModel.Quoted **optional** 
 *    Model displayed for payments added prior to "Confirm and Book" shown in the "Payment Breakdown".

 * PaymentModel.ListView - **required** 
 *    Model used to display charged amount on confirmation page, my trips, or any other post-booking display.
 * PaymentModel.Error - **required** 
 *    Error model when processing the payment.

* `AirChfarExerciseDiscount` - Representation of a discount from exercising a Chfar on a new flight.\n
    Interface defined in `b2b-interfaces/air-chfar`.
* `AirPriceFreezeExerciseDiscount` - Representation of the discount price delta from exercising a price freeze on a frozen flight.\n
    Interface defined in `b2b-interfaces/air-price-freeze`.
* `ApplePay` - Payments performed through Apple Pay.\n
    Interface defined in `b2bportal-tripadvisor-bff`.
* `Card` - Payments made via Spreedly card api. Allows orders to be purchased with credit or debit cards.\n
    Interface defined in `b2b-interfaces/card`.
* `DisruptionProtectionCredit` - Representation of the exercising of a disruption protection, on a new flight.\n
    Interface defined in `Tysons/server`.
* `FintechBundleDiscount` - Representation of a synthetic discount for selecting both disruption protection + CFAR offers.\n
    Interface defined in `b2b-interfaces/air-disruption`.,
    
* `GooglePay` - Payments performed through Google Pay.\n
    Interface defined in `b2bportal-tripadvisor-bff`.
* `HotelPriceFreezeDeposit` - Representation of a discount for purchasing a frozen hotel, amounting to the value of the price freeze.\n
    Interface defined in `Tysons/server`.
* `HotelPriceFreezeExerciseDiscount` - Representation of a discount for purchasing a frozen hotel, amounting to the discount price delta from
    exercising of the price freeze.\n
    Interface defined in `Tysons/server`.
* `NequiPocketPayment` - Payments via nequi pocket pay. Can only be used for tenant=nequi.\n
    Interface defined in `b2bportal-nequi-bff`.
* `NupayPayment` - Nubank, tenant specific, payment integration. Can only be used for tenant=nubank.\n
    Interface defined in `b2bportal-nubank-bff`.
* `PackageSyntheticDiscount` - Representation of a synthetic discount for booking a hotel+flight package.\n
    Interface defined in `Tysons/server`.
* `PayPal` - Payments performed through PayPal.\n
    Interface defined in `b2bportal-hopper-web-bff`.
* `PriceFreezeExerciseDiscount` - Representation of a discount for purchasing a frozen product, amounting to the discount price delta from
    exercising of the price freeze.\n
    Interface defined in `b2b-interfaces/pricefreeze`.
* `Rewards` - Payments made via Capital One travel rewards. Can only be used for tenant=capone,capone-corporate.\n
    Interface defined in `Tysons/server`
* `TravelWalletCredit` - Representation of travel wallet credits or carror cash, stored in `Scranton`.\n
    Interface defined in `Tysons/server`.
* `TravelWalletOffer` - Representation of any offer sourced from `Scranton`.\n
    Interface defined in `Tysons/server`.
* `UberPayment` - Uber operated payment processor. Can only be used for tenant=uber.\n
    Interface defined in `b2bportal-uber-bff`.
* `VirginAuVffPoints` - Representation of Virgin Australia's Velocity Frequent Flyer Points which can be used to purchase travel.\n
    Interface defined in `b2bportal-virgin-au-bff`.,
    
* `Wallet` - Payments performed through `Scranton` wallet.\n
    Interface defined in `b2bportal-tripadvisor-bff`.
 * @export
 * @enum {string}
 */

export const Payment = {
    AirChfarExerciseDiscount: 'AirChfarExerciseDiscount',
    AirPriceFreezeExerciseDiscount: 'AirPriceFreezeExerciseDiscount',
    ApplePay: 'ApplePay',
    Card: 'Card',
    DisruptionProtectionCredit: 'DisruptionProtectionCredit',
    FintechBundleDiscount: 'FintechBundleDiscount',
    GooglePay: 'GooglePay',
    HotelPriceFreezeDeposit: 'HotelPriceFreezeDeposit',
    HotelPriceFreezeExerciseDiscount: 'HotelPriceFreezeExerciseDiscount',
    NequiPocketPayment: 'NequiPocketPayment',
    NupayPayment: 'NupayPayment',
    PackageSyntheticDiscount: 'PackageSyntheticDiscount',
    PayPal: 'PayPal',
    PriceFreezeExerciseDiscount: 'PriceFreezeExerciseDiscount',
    Rewards: 'Rewards',
    TravelWalletCredit: 'TravelWalletCredit',
    TravelWalletOffer: 'TravelWalletOffer',
    UberPayment: 'UberPayment',
    VirginAuVffPoints: 'VirginAuVffPoints',
    Wallet: 'Wallet'
} as const;

export type Payment = typeof Payment[keyof typeof Payment];


/**
 * This model is attached to each reservation in order to display a payment breakdown in My Trips

 * `paymentLineItems` - All payments used in the purchase of the Itinerary
 * @export
 * @interface PaymentBreakdown
 */
export interface PaymentBreakdown {
    /**
     * All payments used in the purchase of the Itinerary
     * @type {Array<PaymentOpaqueValue>}
     * @memberof PaymentBreakdown
     */
    'paymentLineItems': Array<PaymentOpaqueValue>;
}
/**
 * Model used to generify shared types across any product or payment type. The type of `OpaqueValue`
is a shared value between the FE and BFF. As a result each implementation of the purchase interface
can use different products/payments or even different versions of products or payments.
 * @export
 * @interface PaymentOpaqueValue
 */
export interface PaymentOpaqueValue {
    'type': Payment;
    'value': any;
}


/**
 * @type Penalty
 * @export
 */
export type Penalty = { Penalty: 'FlatFee' } & PenaltyFlatFee | { Penalty: 'Free' } & PenaltyFree | { Penalty: 'NonRefundable' } & PenaltyNonRefundable | { Penalty: 'NumberOfDays' } & PenaltyNumberOfDays | { Penalty: 'PercentageTotal' } & PenaltyPercentageTotal;

export const PenaltyEnum = {
    FlatFee: 'FlatFee',
    Free: 'Free',
    NonRefundable: 'NonRefundable',
    NumberOfDays: 'NumberOfDays',
    PercentageTotal: 'PercentageTotal'
} as const;

export type PenaltyEnum = typeof PenaltyEnum[keyof typeof PenaltyEnum];


export interface PenaltyFlatFee {
    'fee': Amount;
    'Penalty': PenaltyEnum;
}


export interface PenaltyFree {
    'Penalty': PenaltyEnum;
}


export interface PenaltyNonRefundable {
    'Penalty': PenaltyEnum;
}


export interface PenaltyNumberOfDays {
    'num': number;
    'Penalty': PenaltyEnum;
}


export interface PenaltyPercentageTotal {
    'percentage': number;
    'Penalty': PenaltyEnum;
}


/**
 * policy result for ground in a pending status
 * @export
 * @interface Pending
 */
export interface Pending {
    'GroundCancelScenario': GroundCancelScenarioEnum;
}


/**
 * The person information used in ground context

 * `id` - The ID of the passenger
 * @export
 * @interface Person
 */
export interface Person {
    'givenName': string;
    /**
     * A phone Number. The frontend should validate the phone number since the request will fail if it doesn't match the pattern
     * @type {string}
     * @memberof Person
     */
    'phoneNumber'?: string;
    'middleName'?: string;
    /**
     * An email address that matches given regex pattern. The frontend should validate the emails address since the request will fail if it doesn't match the pattern
     * @type {string}
     * @memberof Person
     */
    'emailAddress'?: string;
    'driverLicense'?: DriverLicense;
    'surname': string;
    /**
     * The ID of the passenger
     * @type {string}
     * @memberof Person
     */
    'id': string;
}
export interface PickUpInformation {
    'pickUpType'?: PickUpType;
    'distance'?: number;
    'distanceUnit'?: DistanceUnit;
}


export const PickUpType = {
    Airport: 'Airport',
    MeetAndGreet: 'MeetAndGreet',
    Shuttle: 'Shuttle'
} as const;

export type PickUpType = typeof PickUpType[keyof typeof PickUpType];


/**
 * `placeId` - Google Place ID
 * `searchTerm` - Search term used for the place
 * `placeTypes` - Types of places
 * @export
 * @interface Place
 */
export interface Place {
    /**
     * Google Place ID
     * @type {string}
     * @memberof Place
     */
    'placeId': string;
    /**
     * Search term used for the place
     * @type {string}
     * @memberof Place
     */
    'searchTerm': string;
    /**
     * Types of places
     * @type {Array<string>}
     * @memberof Place
     */
    'placeTypes': Array<string>;
    'GroundSelection': GroundSelectionEnum;
}


/**
 * @type PlaceId
 * Unique identifier for the suggestion
 * @export
 */
export type PlaceId = { Id: 'Flight' } & Flight | { Id: 'Grounds' } & Grounds;

export const PlaceIdEnum = {
    Flight: 'Flight',
    Grounds: 'Grounds'
} as const;

export type PlaceIdEnum = typeof PlaceIdEnum[keyof typeof PlaceIdEnum];


export interface PolicyCompliance {
    'isInPolicy': boolean;
    'reasons': Array<string>;
}
export interface PriceChange {
    'from'?: number;
    'to'?: number;
    'currency'?: string;
    'GroundError': GroundErrorEnum;
}


/**
 * Price in fiat currency as well as any with rewards/account specific currency
 * @export
 * @interface Prices
 */
export interface Prices {
    'fiat': FiatPrice;
    'accountSpecific': { [key: string]: AccountPrice; };
}
/**
 * Cancelation fulfillment failed to cancel the ground
 * @export
 * @interface ProductFailure
 */
export interface ProductFailure {
    'GroundCancelFulfillPollResponse': GroundCancelFulfillPollResponseEnum;
    'Aborted': GroundCancelFulfillPollResponseAbortedEnum;
}


export interface RateUnavailable {
    'GroundError': GroundErrorEnum;
}


/**
 * Cancelation fulfillment failed to refund one or more payment method(s)
 * @export
 * @interface RefundFailure
 */
export interface RefundFailure {
    'GroundCancelFulfillPollResponse': GroundCancelFulfillPollResponseEnum;
    'Aborted': GroundCancelFulfillPollResponseAbortedEnum;
}


export const RegionType = {
    airport: 'airport',
    city: 'city'
} as const;

export type RegionType = typeof RegionType[keyof typeof RegionType];


export interface Remark {
    'key': string;
    'value': string;
}
export interface RentalRate {
    'feesSummary': FeesSummary;
    'payAtDesk': FiatPrice;
    'extraInfoSummary'?: ExtraInfoAmount;
    'base': FiatPrice;
    'totalCharge': Prices;
    'extensions': Extensions;
    'payNow': Prices;
}
/**
 * The information of a ground booking

 * `dailyCharge` - The total charge per day for the vehicle
 * `state` - GroundReservation state
 * `cancellationRules` - Rules for cancellation
 * `vehicle` - Vehicle information
 * `payAtDesk` - The amount that can be paid at the desk(shop)
 * `reservationId` - User facing ground reservation confirmation code
 * `vendorMessages` - Messages from vendor
 * `supplier` - Supplier of booked car
 * `totalCharge` - The total price include baseRate and fees for the whole rental period
 * `internalGroundBookingId` - Internal ground booking identifier
 * `fees` - The total fees and taxes for the whole rental period
 * `confirmationInfo` - Confirmation information comes from provider and supplier
 * `payNow` - The amount that can be paid at online
 * `pickUp` - Pick date time and location
 * `dropOff` - Pick date time and location
 * `baseRate` - The total base rate for the whole rental period
 * `driverInfo` - Driver information
 * `vendor` - Vendor of booked car
 * `bookingDate` - Booking date and time
 * @export
 * @interface Reservation
 */
export interface Reservation {
    'dailyCharge'?: Prices;
    'state': ReservationState;
    'cancellationRules'?: RestrictionCancel;
    'vehicle': Vehicle;
    'payAtDesk': FiatPrice;
    /**
     * User facing ground reservation confirmation code
     * @type {string}
     * @memberof Reservation
     */
    'reservationId'?: string;
    'vendorMessages'?: VendorMessages;
    'supplier': GroundSupplier;
    'totalCharge': Prices;
    /**
     * Internal ground booking identifier
     * @type {string}
     * @memberof Reservation
     */
    'internalGroundBookingId': string;
    'fees': FiatPrice;
    'confirmationInfo'?: ConfirmationInfo;
    'payNow': Prices;
    'pickUp': LocationBookDateTime;
    'dropOff': LocationBookDateTime;
    'baseRate': FiatPrice;
    'driverInfo': Person;
    'vendor': GroundVendor;
    /**
     * Booking date and time
     * @type {string}
     * @memberof Reservation
     */
    'bookingDate': string;
}
/**
 * @type ReservationState
 * GroundReservation state
 * @export
 */
export type ReservationState = { ReservationState: 'Cancelled' } & GroundReservationStateCancelled | { ReservationState: 'Confirmed' } & GroundReservationStateConfirmed | { ReservationState: 'Failure' } & GroundReservationStateFailure | { ReservationState: 'Pending' } & GroundReservationStatePending;

export const ReservationStateEnum = {
    Cancelled: 'Cancelled',
    Confirmed: 'Confirmed',
    Failure: 'Failure',
    Pending: 'Pending'
} as const;

export type ReservationStateEnum = typeof ReservationStateEnum[keyof typeof ReservationStateEnum];


export const ReservationStateReason = {
    BookExtBadRequest: 'BookExtBadRequest',
    BookExtPriceChanged: 'BookExtPriceChanged',
    BookExtServiceUnavailable: 'BookExtServiceUnavailable',
    BookExtTimeout: 'BookExtTimeout',
    BookExtUnavailability: 'BookExtUnavailability',
    BookFailedPayment: 'BookFailedPayment',
    BookPriceChanged: 'BookPriceChanged',
    BookProviderUnavailable: 'BookProviderUnavailable',
    CancelByAgentRequest: 'CancelByAgentRequest',
    CancelLongPollRequest: 'CancelLongPollRequest',
    CancelRetrieveLongPoll: 'CancelRetrieveLongPoll',
    CancelUserRequest: 'CancelUserRequest',
    CancellationAttemptFailed: 'CancellationAttemptFailed',
    CancellationFeesApplicable: 'CancellationFeesApplicable',
    InvalidLoyaltyNumber: 'InvalidLoyaltyNumber',
    LoyaltyNameMismatch: 'LoyaltyNameMismatch',
    MoRPriceChanged: 'MoRPriceChanged',
    Unspecified: 'Unspecified'
} as const;

export type ReservationStateReason = typeof ReservationStateReason[keyof typeof ReservationStateReason];


export interface ResponseLocation {
    'coordinates'?: Coordinates;
    'city': string;
    'airportCode'?: string;
    'name': string;
    /**
     * A phone Number. The frontend should validate the phone number since the request will fail if it doesn't match the pattern
     * @type {string}
     * @memberof ResponseLocation
     */
    'phoneNumber'?: string;
    'country': string;
    'address': string;
}
/**
 * @type RestrictionCancel
 * Rules for cancellation
 * @export
 */
export type RestrictionCancel = { RestrictionCancel: 'Conditional' } & RestrictionCancelConditional | { RestrictionCancel: 'ConditionalAfterBooking' } & RestrictionCancelConditionalAfterBooking | { RestrictionCancel: 'Free' } & RestrictionCancelFree | { RestrictionCancel: 'NonRefundable' } & RestrictionCancelNonRefundable | { RestrictionCancel: 'Paid' } & RestrictionCancelPaid | { RestrictionCancel: 'SteppedCancellationRule' } & RestrictionCancelSteppedCancellationRule;

export interface RestrictionCancelConditional {
    'hoursBeforePickUp': number;
    'description'?: string;
    'RestrictionCancel': RestrictionCancelEnum;
}


export interface RestrictionCancelConditionalAfterBooking {
    'hoursAfterBooking': number;
    'description'?: string;
    'RestrictionCancel': RestrictionCancelEnum;
}


export const RestrictionCancelEnum = {
    Conditional: 'Conditional',
    ConditionalAfterBooking: 'ConditionalAfterBooking',
    Free: 'Free',
    NonRefundable: 'NonRefundable',
    Paid: 'Paid',
    SteppedCancellationRule: 'SteppedCancellationRule'
} as const;

export type RestrictionCancelEnum = typeof RestrictionCancelEnum[keyof typeof RestrictionCancelEnum];


export interface RestrictionCancelFree {
    'description'?: string;
    'RestrictionCancel': RestrictionCancelEnum;
}


export interface RestrictionCancelNonRefundable {
    'description'?: string;
    'RestrictionCancel': RestrictionCancelEnum;
}


export interface RestrictionCancelPaid {
    'RestrictionCancel': RestrictionCancelEnum;
}


export interface RestrictionCancelSteppedCancellationRule {
    'rules': Array<Rule>;
    'RestrictionCancel': RestrictionCancelEnum;
}


/**
 * Contextual information for the availability results.
 * @export
 * @interface ResultsContext
 */
export interface ResultsContext {
    'vendors': { [key: string]: GroundVendor; };
    'suppliers': { [key: string]: GroundSupplier; };
    'opaqueShopRequestContext': string;
}
export interface RewardsNotFound {
    'GroundError': GroundErrorEnum;
}


export interface Rule {
    'penalty': Penalty;
    'from': string;
    'until': string;
}
/**
 * `opaqueShopRequestContext` - Context of the opaque shop request directly from availability response
 * `opaqueShopRequestVehicle` - Vehicle details of opaque shop request directly from availability response
 * @export
 * @interface ShopRequest
 */
export interface ShopRequest {
    /**
     * Context of the opaque shop request directly from availability response
     * @type {string}
     * @memberof ShopRequest
     */
    'opaqueShopRequestContext': string;
    /**
     * Vehicle details of opaque shop request directly from availability response
     * @type {string}
     * @memberof ShopRequest
     */
    'opaqueShopRequestVehicle': string;
}
/**
 * `elements` - List of elements containing information about additional GPS, third party insurance, extra driver, etc.
 * `needsDriverDetails` - Optional flag indicating if driver details are needed
 * `description` - Description of the shop response
 * `collisionDamageWaiver` - Optional flag indicating if collision damage waiver is included
 * `vendorMessages` - Optional vendor messages related to the shop response
 * `opaqueBookRequest` - Opaque book request string
 * @export
 * @interface ShopResponse
 */
export interface ShopResponse {
    /**
     * List of elements containing information about additional GPS, third party insurance, extra driver, etc.
     * @type {Array<ShopResponseElement>}
     * @memberof ShopResponse
     */
    'elements': Array<ShopResponseElement>;
    /**
     * Optional flag indicating if driver details are needed
     * @type {boolean}
     * @memberof ShopResponse
     */
    'needsDriverDetails'?: boolean;
    /**
     * Description of the shop response
     * @type {string}
     * @memberof ShopResponse
     */
    'description': string;
    /**
     * Optional flag indicating if collision damage waiver is included
     * @type {boolean}
     * @memberof ShopResponse
     */
    'collisionDamageWaiver'?: boolean;
    'vendorMessages'?: VendorMessages;
    /**
     * Opaque book request string
     * @type {string}
     * @memberof ShopResponse
     */
    'opaqueBookRequest': string;
}
/**
 * `contactSupport` - Optional contact support information for the shop response element
 * `name` - Name of the shop response element
 * `description` - Description of the shop response element
 * `disclaimer` - Optional disclaimer for the shop response element
 * `trackingProperties` - Optional tracking properties for the shop response element
 * `sellingPoints` - Optional list of selling points for the shop response element
 * `links` - List of links related to the shop response element
 * `id` - Unique identifier for the shop response element
 * `charges` - List of charges associated with the shop response element
 * `prePayable` - Flag indicating if the element is pre-payable
 * `remarks` - List of remarks associated with the shop response element
 * `kind` - Kind of the shop response element
 * `isDefault` - Flag indicating if the element is the default option
 * @export
 * @interface ShopResponseElement
 */
export interface ShopResponseElement {
    /**
     * Optional contact support information for the shop response element
     * @type {string}
     * @memberof ShopResponseElement
     */
    'contactSupport'?: string;
    /**
     * Name of the shop response element
     * @type {string}
     * @memberof ShopResponseElement
     */
    'name': string;
    /**
     * Description of the shop response element
     * @type {string}
     * @memberof ShopResponseElement
     */
    'description': string;
    /**
     * Optional disclaimer for the shop response element
     * @type {string}
     * @memberof ShopResponseElement
     */
    'disclaimer'?: string;
    /**
     * Optional tracking properties for the shop response element
     * @type {any}
     * @memberof ShopResponseElement
     */
    'trackingProperties'?: any;
    /**
     * Optional list of selling points for the shop response element
     * @type {Array<string>}
     * @memberof ShopResponseElement
     */
    'sellingPoints'?: Array<string>;
    /**
     * List of links related to the shop response element
     * @type {Array<Link>}
     * @memberof ShopResponseElement
     */
    'links': Array<Link>;
    /**
     * Unique identifier for the shop response element
     * @type {string}
     * @memberof ShopResponseElement
     */
    'id': string;
    /**
     * List of charges associated with the shop response element
     * @type {Array<Charge>}
     * @memberof ShopResponseElement
     */
    'charges': Array<Charge>;
    /**
     * Flag indicating if the element is pre-payable
     * @type {boolean}
     * @memberof ShopResponseElement
     */
    'prePayable': boolean;
    /**
     * List of remarks associated with the shop response element
     * @type {Array<Remark>}
     * @memberof ShopResponseElement
     */
    'remarks': Array<Remark>;
    'kind': ShopResponseElementKind;
    /**
     * Flag indicating if the element is the default option
     * @type {boolean}
     * @memberof ShopResponseElement
     */
    'isDefault': boolean;
}


/**
 * 

* `Amenities` - Amenities such as GPS, child seats, etc.
* `BabyOnBoard` - Baby on board related ancillaries
* `ExtraDriver` - Additional driver related ancillaries
* `General` - General ancillaries not falling into other categories
* `Insurance` - Insurance provided by the vendor
* `InsuranceExternal` - Insurance provided by an external provider (CoverGenius)
* `Other` - Other types of ancillaries
* `ReBookingProtection` - Rebooking protection related ancillaries
 * @export
 * @enum {string}
 */

export const ShopResponseElementKind = {
    Amenities: 'Amenities',
    BabyOnBoard: 'BabyOnBoard',
    ExtraDriver: 'ExtraDriver',
    General: 'General',
    Insurance: 'Insurance',
    InsuranceExternal: 'InsuranceExternal',
    Other: 'Other',
    ReBookingProtection: 'ReBookingProtection'
} as const;

export type ShopResponseElementKind = typeof ShopResponseElementKind[keyof typeof ShopResponseElementKind];


/**
 * `itineraryId` - ID of the ground booking
 * @export
 * @interface SingleItineraryRequest
 */
export interface SingleItineraryRequest {
    /**
     * ID of the ground booking
     * @type {string}
     * @memberof SingleItineraryRequest
     */
    'itineraryId': string;
}
export interface SingleItineraryResponse {
    'itinerary': Itinerary;
}
/**
 * `id` - Unique identifier for the suggestion
 * `label` - Main label for the suggestion
 * `trackingPropertiesV2` - Tracking properties for the suggestion
 * `subLabel` - Optional sub-label for the suggestion
 * @export
 * @interface Suggestion
 */
export interface Suggestion {
    'id': PlaceId;
    /**
     * Main label for the suggestion
     * @type {string}
     * @memberof Suggestion
     */
    'label': string;
    'trackingPropertiesV2': TrackingProperties;
    /**
     * Optional sub-label for the suggestion
     * @type {string}
     * @memberof Suggestion
     */
    'subLabel'?: string;
}
export interface TimeAndPlace {
    'coordinates': Coordinates;
    'pickUpInformation'?: PickUpInformation;
    'metersToRequested'?: number;
    'address': string;
    'time': string;
}
export interface TrackingProperties {
    'properties'?: any;
    'encryptedProperties'?: string;
}
/**
 * Type of transmission - automatic or manual
 * @export
 * @enum {string}
 */

export const TransmissionType = {
    Automatic: 'Automatic',
    Cvt: 'Cvt',
    Manual: 'Manual'
} as const;

export type TransmissionType = typeof TransmissionType[keyof typeof TransmissionType];


/**
 * `percentage` - Percentage discount amount for percentage offer
 * `amount` - Discount amount in USD
 * `imageId` - Image name that's set in the offer config
 * `maxDiscountAmount` - Max discount amount in USD for percentage offer
 * @export
 * @interface TravelWalletOffer
 */
export interface TravelWalletOffer {
    /**
     * Percentage discount amount for percentage offer
     * @type {number}
     * @memberof TravelWalletOffer
     */
    'percentage'?: number;
    'shopPageBanner'?: string;
    'funnels': Array<Funnel>;
    'amount': Amount;
    'expiresOn': string;
    'availabilityPageBanner'?: string;
    'id': string;
    /**
     * Image name that's set in the offer config
     * @type {string}
     * @memberof TravelWalletOffer
     */
    'imageId'?: string;
    'trackingPropertiesV2': TrackingProperties;
    'termsAndConditions'?: string;
    'title': string;
    'landingPageBanner'?: string;
    'maxDiscountAmount'?: Amount;
    'descriptions': Array<string>;
}
export interface Unknown {
    'GroundError': GroundErrorEnum;
}


/**
 * Cancelation fulfillment failed due to unknown reason
 * @export
 * @interface UnknownFailure
 */
export interface UnknownFailure {
    'trackingProperties': TrackingProperties;
    'GroundCancelFulfillPollResponse': GroundCancelFulfillPollResponseEnum;
    'Aborted': GroundCancelFulfillPollResponseAbortedEnum;
}


export interface Unlimited {
    'DistKind': DistKindEnum;
}


/**
 * Information about the vehicle itself that can be rented

 * `name` - Name of the vehicle
 * `fuelType` - The type of fuel used by the vehicle
 * `vehicleType` - The type of the vehicle. Ex. Car, SUV, Van, etc.
 * `doorsQty` - The number of doors on the vehicle
 * `driveType` - Type of drive - two wheel or four wheel
 * `id` - Unique identifier for the vehicle from the supplier
 * `airbag` - Indicates if the vehicle has airbag
 * `passengerQty` - The maximum number of passengers the vehicle can accommodate
 * `acrissCode` - Four-letter code describing the vehicle
 * `bagsInfo` - Map of bag sizes to their capacities
 * `category` - The category of the vehicle. Ex. Mini, Economy, Compact, etc.
 * `kind` - Kind of the vehicle. For clients of b2b-coordinators, this will be set to None. This field is retained for backward compatibility with Tysons'.
 * `airConditioning` - Indicates if the vehicle has air conditioning
 * `transmissionType` - Type of transmission - automatic or manual
 * `images` - Optional map of image kinds to their URLs
 * @export
 * @interface Vehicle
 */
export interface Vehicle {
    /**
     * Name of the vehicle
     * @type {string}
     * @memberof Vehicle
     */
    'name': string;
    'fuelType': FuelType;
    'vehicleType'?: VehicleType;
    /**
     * The number of doors on the vehicle
     * @type {number}
     * @memberof Vehicle
     */
    'doorsQty'?: number;
    'driveType': DriveType;
    /**
     * Unique identifier for the vehicle from the supplier
     * @type {string}
     * @memberof Vehicle
     */
    'id': string;
    /**
     * Indicates if the vehicle has airbag
     * @type {boolean}
     * @memberof Vehicle
     */
    'airbag'?: boolean;
    /**
     * The maximum number of passengers the vehicle can accommodate
     * @type {number}
     * @memberof Vehicle
     */
    'passengerQty': number;
    /**
     * Four-letter code describing the vehicle
     * @type {string}
     * @memberof Vehicle
     */
    'acrissCode': string;
    /**
     * Map of bag sizes to their capacities
     * @type {{ [key: string]: number; }}
     * @memberof Vehicle
     */
    'bagsInfo': { [key: string]: number; };
    'category'?: VehicleCategory;
    'kind'?: VehicleKind;
    /**
     * Indicates if the vehicle has air conditioning
     * @type {boolean}
     * @memberof Vehicle
     */
    'airConditioning': boolean;
    'transmissionType': TransmissionType;
    /**
     * Optional map of image kinds to their URLs
     * @type {{ [key: string]: string; }}
     * @memberof Vehicle
     */
    'images'?: { [key: string]: string; };
}


/**
 * `vendorRef` - a code identifying a vendor
 * `supplierRef` - a code identifying a supplier
 * @export
 * @interface VehicleAvail
 */
export interface VehicleAvail {
    /**
     * a code identifying a vendor
     * @type {string}
     * @memberof VehicleAvail
     */
    'vendorRef': string;
    'vehicle': Vehicle;
    'trackingPropertiesV2': TrackingProperties;
    'pickUp': LocationDateTimeRef;
    'dropOff': LocationDateTimeRef;
    'rentalRate': RentalRate;
    /**
     * a code identifying a supplier
     * @type {string}
     * @memberof VehicleAvail
     */
    'supplierRef': string;
}
/**
 * `dailyCharge` - The total charge per day for the vehicle
 * `pickupLocationName` - The name of pickup location. Ex. Store name, not translated
 * `payAtDesk` - The amount that can be paid at the desk(shop)
 * `totalCharge` - The total price include baseRate and fees for the whole rental period
 * `fees` - The total fees and taxes for the whole rental period
 * `payNow` - The amount that can be paid at online
 * `supplierName` - The name of supplier, not translated
 * `baseRate` - The total base rate for the whole rental period
 * @export
 * @interface VehicleAvailability
 */
export interface VehicleAvailability {
    'vendorRef': string;
    'hasUnlimitedMileage': boolean;
    'dailyCharge'?: Prices;
    'cancellationPolicy': RestrictionCancel;
    /**
     * The name of pickup location. Ex. Store name, not translated
     * @type {string}
     * @memberof VehicleAvailability
     */
    'pickupLocationName'?: string;
    'vehicle': Vehicle;
    'payAtDesk': FiatPrice;
    'collisionDamageWaiver'?: boolean;
    'requiresCreditCard': boolean;
    'rateCode'?: string;
    'totalCharge': Prices;
    'markup'?: Markup;
    'opaqueShopRequest': string;
    'fees': FiatPrice;
    'payNow': Prices;
    'pickUp': TimeAndPlace;
    /**
     * The name of supplier, not translated
     * @type {string}
     * @memberof VehicleAvailability
     */
    'supplierName'?: string;
    'corporateTravel'?: CorporateTravel;
    'offer'?: TravelWalletOffer;
    'dropOff': TimeAndPlace;
    'baseRate': FiatPrice;
    'fuelPolicy'?: FuelPolicy;
    'supplierRef': string;
}
/**
 * The category of the vehicle. Ex. Mini, Economy, Compact, etc.
 * @export
 * @enum {string}
 */

export const VehicleCategory = {
    Compact: 'Compact',
    CompactElite: 'CompactElite',
    Economy: 'Economy',
    EconomyElite: 'EconomyElite',
    Fullsize: 'Fullsize',
    FullsizeElite: 'FullsizeElite',
    Intermediate: 'Intermediate',
    IntermediateElite: 'IntermediateElite',
    Luxury: 'Luxury',
    LuxuryElite: 'LuxuryElite',
    Mini: 'Mini',
    MiniElite: 'MiniElite',
    Oversize: 'Oversize',
    Premium: 'Premium',
    PremiumElite: 'PremiumElite',
    Special: 'Special',
    Standard: 'Standard',
    StandardElite: 'StandardElite',
    Unspecified: 'Unspecified'
} as const;

export type VehicleCategory = typeof VehicleCategory[keyof typeof VehicleCategory];


/**
 * Kind of the vehicle. For clients of b2b-coordinators, this will be set to None. This field is retained for backward compatibility with Tysons'.
 * @export
 * @enum {string}
 */

export const VehicleKind = {
    CompactCar: 'CompactCar',
    CompactCommercialVanTruck: 'CompactCommercialVanTruck',
    CompactConvertible: 'CompactConvertible',
    CompactCrossover: 'CompactCrossover',
    CompactElectricSUV: 'CompactElectricSUV',
    CompactElectricVan: 'CompactElectricVan',
    CompactEliteCar: 'CompactEliteCar',
    CompactEliteCoupe: 'CompactEliteCoupe',
    CompactEliteCrossover: 'CompactEliteCrossover',
    CompactEliteElectricCrossover: 'CompactEliteElectricCrossover',
    CompactEliteSUV: 'CompactEliteSUV',
    CompactEliteSportsCar: 'CompactEliteSportsCar',
    CompactHybridCar: 'CompactHybridCar',
    CompactRecreationalVehicle: 'CompactRecreationalVehicle',
    CompactSUV: 'CompactSUV',
    CompactVan: 'CompactVan',
    EconomyCar: 'EconomyCar',
    EconomyCrossover: 'EconomyCrossover',
    EconomyEliteCar: 'EconomyEliteCar',
    EconomyHybridSUV: 'EconomyHybridSUV',
    EconomySUV: 'EconomySUV',
    EconomySpecial: 'EconomySpecial',
    ExactCarMatch: 'ExactCarMatch',
    FullSize2WheelVehicle: 'FullSize2WheelVehicle',
    FullSizeCar: 'FullSizeCar',
    FullSizeCrossover: 'FullSizeCrossover',
    FullSizeElectricCar: 'FullSizeElectricCar',
    FullSizeElite2WheelVehicle: 'FullSizeElite2WheelVehicle',
    FullSizeEliteCar: 'FullSizeEliteCar',
    FullSizeEliteSUV: 'FullSizeEliteSUV',
    FullSizeEliteVan: 'FullSizeEliteVan',
    FullSizeHybridCar: 'FullSizeHybridCar',
    FullSizeOpenAirAllTerrain: 'FullSizeOpenAirAllTerrain',
    FullSizePickupTruck: 'FullSizePickupTruck',
    FullSizePickupTruckWithExtendedCab: 'FullSizePickupTruckWithExtendedCab',
    FullSizeRecreationalVehicle: 'FullSizeRecreationalVehicle',
    FullSizeSUV: 'FullSizeSUV',
    FullSizeSpecial: 'FullSizeSpecial',
    FullSizeSportsCar: 'FullSizeSportsCar',
    FullSizeVan: 'FullSizeVan',
    FullSizeWagon: 'FullSizeWagon',
    Luxury2WheelVehicle: 'Luxury2WheelVehicle',
    LuxuryCar: 'LuxuryCar',
    LuxuryConvertible: 'LuxuryConvertible',
    LuxuryCrossover: 'LuxuryCrossover',
    LuxuryElectricSUV: 'LuxuryElectricSUV',
    LuxuryEliteCar: 'LuxuryEliteCar',
    LuxuryEliteElectricCar: 'LuxuryEliteElectricCar',
    LuxuryEliteSUV: 'LuxuryEliteSUV',
    LuxuryEliteSpecial: 'LuxuryEliteSpecial',
    LuxuryEliteSportsCar: 'LuxuryEliteSportsCar',
    LuxurySUV: 'LuxurySUV',
    LuxurySpecial: 'LuxurySpecial',
    LuxurySportsCar: 'LuxurySportsCar',
    MidSizeCar: 'MidSizeCar',
    MidSizeCommercialVanTruck: 'MidSizeCommercialVanTruck',
    MidSizeConvertible: 'MidSizeConvertible',
    MidSizeCrossover: 'MidSizeCrossover',
    MidSizeElectricCar: 'MidSizeElectricCar',
    MidSizeElectricSUV: 'MidSizeElectricSUV',
    MidSizeEliteCar: 'MidSizeEliteCar',
    MidSizeEliteConvertible: 'MidSizeEliteConvertible',
    MidSizeEliteCrossover: 'MidSizeEliteCrossover',
    MidSizeEliteElectricCar: 'MidSizeEliteElectricCar',
    MidSizeEliteElectricCrossover: 'MidSizeEliteElectricCrossover',
    MidSizeEliteSUV: 'MidSizeEliteSUV',
    MidSizeEliteSportsCar: 'MidSizeEliteSportsCar',
    MidSizeHybridCar: 'MidSizeHybridCar',
    MidSizeLimousine: 'MidSizeLimousine',
    MidSizeOpenAirAllTerrain: 'MidSizeOpenAirAllTerrain',
    MidSizePickupTruck: 'MidSizePickupTruck',
    MidSizeSUV: 'MidSizeSUV',
    MidSizeSpecial: 'MidSizeSpecial',
    MidSizeVan: 'MidSizeVan',
    MiniCar: 'MiniCar',
    MiniEliteVan: 'MiniEliteVan',
    MiniSUV: 'MiniSUV',
    MiniVan: 'MiniVan',
    MysteryCar: 'MysteryCar',
    OverSizePickupTruckWithExtendedCab: 'OverSizePickupTruckWithExtendedCab',
    OverSizeVan: 'OverSizeVan',
    Premium2WheelVehicle: 'Premium2WheelVehicle',
    PremiumCar: 'PremiumCar',
    PremiumConvertible: 'PremiumConvertible',
    PremiumCrossover: 'PremiumCrossover',
    PremiumElectricCar: 'PremiumElectricCar',
    PremiumEliteConvertible: 'PremiumEliteConvertible',
    PremiumEliteCrossover: 'PremiumEliteCrossover',
    PremiumEliteSUV: 'PremiumEliteSUV',
    PremiumEliteSportsCar: 'PremiumEliteSportsCar',
    PremiumEliteVan: 'PremiumEliteVan',
    PremiumLimousine: 'PremiumLimousine',
    PremiumPickupTruck: 'PremiumPickupTruck',
    PremiumPickupTruckWithExtendedCab: 'PremiumPickupTruckWithExtendedCab',
    PremiumSUV: 'PremiumSUV',
    PremiumSportsCar: 'PremiumSportsCar',
    PremiumVan: 'PremiumVan',
    PremiumWagon: 'PremiumWagon',
    SpecialCar: 'SpecialCar',
    SpecialConvertible: 'SpecialConvertible',
    SpecialSUV: 'SpecialSUV',
    SpecialSportsCar: 'SpecialSportsCar',
    SpecialVan: 'SpecialVan',
    Standard2WheelVehicle: 'Standard2WheelVehicle',
    StandardCar: 'StandardCar',
    StandardCommercialVanTruck: 'StandardCommercialVanTruck',
    StandardConvertible: 'StandardConvertible',
    StandardCoupe: 'StandardCoupe',
    StandardCrossover: 'StandardCrossover',
    StandardElectricCar: 'StandardElectricCar',
    StandardEliteCar: 'StandardEliteCar',
    StandardEliteCoupe: 'StandardEliteCoupe',
    StandardEliteCrossover: 'StandardEliteCrossover',
    StandardEliteElectricSUV: 'StandardEliteElectricSUV',
    StandardEliteSUV: 'StandardEliteSUV',
    StandardEliteSportsCar: 'StandardEliteSportsCar',
    StandardEliteVan: 'StandardEliteVan',
    StandardHybridCar: 'StandardHybridCar',
    StandardHybridSUV: 'StandardHybridSUV',
    StandardOpenAirAllTerrain: 'StandardOpenAirAllTerrain',
    StandardPickupTruck: 'StandardPickupTruck',
    StandardPickupTruckWithExtendedCab: 'StandardPickupTruckWithExtendedCab',
    StandardRecreationalVehicle: 'StandardRecreationalVehicle',
    StandardSUV: 'StandardSUV',
    StandardSportsCar: 'StandardSportsCar',
    StandardVan: 'StandardVan',
    SuppliersChoice: 'SuppliersChoice'
} as const;

export type VehicleKind = typeof VehicleKind[keyof typeof VehicleKind];


/**
 * The type of the vehicle. Ex. Car, SUV, Van, etc.
 * @export
 * @enum {string}
 */

export const VehicleType = {
    Car: 'Car',
    CommercialVanTruck: 'CommercialVanTruck',
    Convertible: 'Convertible',
    Coupe: 'Coupe',
    Crossover: 'Crossover',
    LimousineSedan: 'LimousineSedan',
    Monospace: 'Monospace',
    MotorHome: 'MotorHome',
    OpenAirAllTerrain: 'OpenAirAllTerrain',
    PassengerVan: 'PassengerVan',
    PickUpDoubleCab: 'PickUpDoubleCab',
    PickUpSingleExtendedCar: 'PickUpSingleExtendedCar',
    RecreationalVehicle: 'RecreationalVehicle',
    Roadster: 'Roadster',
    SUV: 'SUV',
    SpecialCar: 'SpecialCar',
    SpecialOfferCar: 'SpecialOfferCar',
    SportsCar: 'SportsCar',
    TwoWheelVehicle: 'TwoWheelVehicle',
    Unspecified: 'Unspecified',
    WagonEstate: 'WagonEstate'
} as const;

export type VehicleType = typeof VehicleType[keyof typeof VehicleType];


export interface VendorExclusionFilter {
    'excludedIdentifiers': Array<string>;
    'AvailabilityFilter': AvailabilityFilterEnum;
}


export interface VendorMessageSection {
    'desc': string;
    'details': Array<VendorMessageSubSection>;
    'linkMsg'?: string;
}
export interface VendorMessageSubSection {
    'title'?: string;
    'text': string;
    'displayText': string;
}
export interface VendorMessages {
    'bookingConditions'?: VendorMessageSection;
    'carRentalPolicy'?: VendorMessageSection;
    'importantInfo'?: VendorMessageSection;
    'pickUpDirections'?: VendorMessageSection;
}

/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Autocomplete a ground location, name, or coordinates
         * @param {GroundQuery} groundQuery 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AutocompleteGroundPost: async (groundQuery: GroundQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groundQuery' is not null or undefined
            assertParamExists('apiV1AutocompleteGroundPost', 'groundQuery', groundQuery)
            const localVarPath = `/api/v1/autocomplete/ground`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(groundQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Ground availability search
         * @param {AvailabilityRequest} availabilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroundAvailabilityPost: async (availabilityRequest: AvailabilityRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'availabilityRequest' is not null or undefined
            assertParamExists('apiV1GroundAvailabilityPost', 'availabilityRequest', availabilityRequest)
            const localVarPath = `/api/v1/ground/availability`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(availabilityRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Itineraries for ground service
         * @param {ItinerariesRequest} itinerariesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroundItinerariesPut: async (itinerariesRequest: ItinerariesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'itinerariesRequest' is not null or undefined
            assertParamExists('apiV1GroundItinerariesPut', 'itinerariesRequest', itinerariesRequest)
            const localVarPath = `/api/v1/ground/itineraries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(itinerariesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Single itinerary for ground service
         * @param {SingleItineraryRequest} singleItineraryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroundItinerariesSinglePut: async (singleItineraryRequest: SingleItineraryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'singleItineraryRequest' is not null or undefined
            assertParamExists('apiV1GroundItinerariesSinglePut', 'singleItineraryRequest', singleItineraryRequest)
            const localVarPath = `/api/v1/ground/itineraries/single`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(singleItineraryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Shop for ground service
         * @param {ShopRequest} shopRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroundShopPost: async (shopRequest: ShopRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shopRequest' is not null or undefined
            assertParamExists('apiV1GroundShopPost', 'shopRequest', shopRequest)
            const localVarPath = `/api/v1/ground/shop`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shopRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Poll the status of an existing Ground Cancel Fulfillment request. Idempotent request. Investigate `/oklahomaOrder` page on the dashboard for failure details.
         * @param {GroundCancelFulfillPollRequest} groundCancelFulfillPollRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SelfserveGroundCancelFulfillPollPut: async (groundCancelFulfillPollRequest: GroundCancelFulfillPollRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groundCancelFulfillPollRequest' is not null or undefined
            assertParamExists('apiV1SelfserveGroundCancelFulfillPollPut', 'groundCancelFulfillPollRequest', groundCancelFulfillPollRequest)
            const localVarPath = `/api/v1/selfserve/ground/cancel/fulfill/poll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(groundCancelFulfillPollRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Start a Ground Cancel Fulfillment using the quoteId from a Cancel Quote. Not an idempotent request, as a quoteId can only be fulfilled once, but subsequent calls with the same quoteId will fail rather than do something like over-refund. Investigate `/oklahomaOrder` page on the dashboard for failure details.
         * @param {GroundCancelFulfillScheduleRequest} groundCancelFulfillScheduleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SelfserveGroundCancelFulfillSchedulePost: async (groundCancelFulfillScheduleRequest: GroundCancelFulfillScheduleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groundCancelFulfillScheduleRequest' is not null or undefined
            assertParamExists('apiV1SelfserveGroundCancelFulfillSchedulePost', 'groundCancelFulfillScheduleRequest', groundCancelFulfillScheduleRequest)
            const localVarPath = `/api/v1/selfserve/ground/cancel/fulfill/schedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(groundCancelFulfillScheduleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Poll the status of an existing Ground Cancel quote request. Idempotent request. Investigate `/oklahomaOrder` page on the dashboard for failure details.
         * @param {GroundCancelQuotePollRequest} groundCancelQuotePollRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SelfserveGroundCancelQuotePollPut: async (groundCancelQuotePollRequest: GroundCancelQuotePollRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groundCancelQuotePollRequest' is not null or undefined
            assertParamExists('apiV1SelfserveGroundCancelQuotePollPut', 'groundCancelQuotePollRequest', groundCancelQuotePollRequest)
            const localVarPath = `/api/v1/selfserve/ground/cancel/quote/poll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(groundCancelQuotePollRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Start a Ground Cancel Quote, in initiate a cancel quote and retrieving quoteId needed for Cancel Fulfillment. Idempotent request. Investigate `/oklahomaOrder` page on the dashboard for failure details.
         * @param {GroundCancelQuoteScheduleRequest} groundCancelQuoteScheduleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SelfserveGroundCancelQuoteSchedulePost: async (groundCancelQuoteScheduleRequest: GroundCancelQuoteScheduleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groundCancelQuoteScheduleRequest' is not null or undefined
            assertParamExists('apiV1SelfserveGroundCancelQuoteSchedulePost', 'groundCancelQuoteScheduleRequest', groundCancelQuoteScheduleRequest)
            const localVarPath = `/api/v1/selfserve/ground/cancel/quote/schedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(groundCancelQuoteScheduleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * Autocomplete a ground location, name, or coordinates
         * @param {GroundQuery} groundQuery 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AutocompleteGroundPost(groundQuery: GroundQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroundResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AutocompleteGroundPost(groundQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV1AutocompleteGroundPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Ground availability search
         * @param {AvailabilityRequest} availabilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1GroundAvailabilityPost(availabilityRequest: AvailabilityRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvailabilityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1GroundAvailabilityPost(availabilityRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV1GroundAvailabilityPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Itineraries for ground service
         * @param {ItinerariesRequest} itinerariesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1GroundItinerariesPut(itinerariesRequest: ItinerariesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ItinerariesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1GroundItinerariesPut(itinerariesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV1GroundItinerariesPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Single itinerary for ground service
         * @param {SingleItineraryRequest} singleItineraryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1GroundItinerariesSinglePut(singleItineraryRequest: SingleItineraryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SingleItineraryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1GroundItinerariesSinglePut(singleItineraryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV1GroundItinerariesSinglePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Shop for ground service
         * @param {ShopRequest} shopRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1GroundShopPost(shopRequest: ShopRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1GroundShopPost(shopRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV1GroundShopPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Poll the status of an existing Ground Cancel Fulfillment request. Idempotent request. Investigate `/oklahomaOrder` page on the dashboard for failure details.
         * @param {GroundCancelFulfillPollRequest} groundCancelFulfillPollRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SelfserveGroundCancelFulfillPollPut(groundCancelFulfillPollRequest: GroundCancelFulfillPollRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroundCancelFulfillPollResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SelfserveGroundCancelFulfillPollPut(groundCancelFulfillPollRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV1SelfserveGroundCancelFulfillPollPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Start a Ground Cancel Fulfillment using the quoteId from a Cancel Quote. Not an idempotent request, as a quoteId can only be fulfilled once, but subsequent calls with the same quoteId will fail rather than do something like over-refund. Investigate `/oklahomaOrder` page on the dashboard for failure details.
         * @param {GroundCancelFulfillScheduleRequest} groundCancelFulfillScheduleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SelfserveGroundCancelFulfillSchedulePost(groundCancelFulfillScheduleRequest: GroundCancelFulfillScheduleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroundCancelFulfillScheduleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SelfserveGroundCancelFulfillSchedulePost(groundCancelFulfillScheduleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV1SelfserveGroundCancelFulfillSchedulePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Poll the status of an existing Ground Cancel quote request. Idempotent request. Investigate `/oklahomaOrder` page on the dashboard for failure details.
         * @param {GroundCancelQuotePollRequest} groundCancelQuotePollRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SelfserveGroundCancelQuotePollPut(groundCancelQuotePollRequest: GroundCancelQuotePollRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroundCancelQuotePollResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SelfserveGroundCancelQuotePollPut(groundCancelQuotePollRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV1SelfserveGroundCancelQuotePollPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Start a Ground Cancel Quote, in initiate a cancel quote and retrieving quoteId needed for Cancel Fulfillment. Idempotent request. Investigate `/oklahomaOrder` page on the dashboard for failure details.
         * @param {GroundCancelQuoteScheduleRequest} groundCancelQuoteScheduleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SelfserveGroundCancelQuoteSchedulePost(groundCancelQuoteScheduleRequest: GroundCancelQuoteScheduleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroundCancelQuoteScheduleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SelfserveGroundCancelQuoteSchedulePost(groundCancelQuoteScheduleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV1SelfserveGroundCancelQuoteSchedulePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * Autocomplete a ground location, name, or coordinates
         * @param {GroundQuery} groundQuery 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AutocompleteGroundPost(groundQuery: GroundQuery, options?: RawAxiosRequestConfig): AxiosPromise<GroundResponse> {
            return localVarFp.apiV1AutocompleteGroundPost(groundQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * Ground availability search
         * @param {AvailabilityRequest} availabilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroundAvailabilityPost(availabilityRequest: AvailabilityRequest, options?: RawAxiosRequestConfig): AxiosPromise<AvailabilityResponse> {
            return localVarFp.apiV1GroundAvailabilityPost(availabilityRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Itineraries for ground service
         * @param {ItinerariesRequest} itinerariesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroundItinerariesPut(itinerariesRequest: ItinerariesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ItinerariesResponse> {
            return localVarFp.apiV1GroundItinerariesPut(itinerariesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Single itinerary for ground service
         * @param {SingleItineraryRequest} singleItineraryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroundItinerariesSinglePut(singleItineraryRequest: SingleItineraryRequest, options?: RawAxiosRequestConfig): AxiosPromise<SingleItineraryResponse> {
            return localVarFp.apiV1GroundItinerariesSinglePut(singleItineraryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Shop for ground service
         * @param {ShopRequest} shopRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroundShopPost(shopRequest: ShopRequest, options?: RawAxiosRequestConfig): AxiosPromise<ShopResponse> {
            return localVarFp.apiV1GroundShopPost(shopRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Poll the status of an existing Ground Cancel Fulfillment request. Idempotent request. Investigate `/oklahomaOrder` page on the dashboard for failure details.
         * @param {GroundCancelFulfillPollRequest} groundCancelFulfillPollRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SelfserveGroundCancelFulfillPollPut(groundCancelFulfillPollRequest: GroundCancelFulfillPollRequest, options?: RawAxiosRequestConfig): AxiosPromise<GroundCancelFulfillPollResponse> {
            return localVarFp.apiV1SelfserveGroundCancelFulfillPollPut(groundCancelFulfillPollRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Start a Ground Cancel Fulfillment using the quoteId from a Cancel Quote. Not an idempotent request, as a quoteId can only be fulfilled once, but subsequent calls with the same quoteId will fail rather than do something like over-refund. Investigate `/oklahomaOrder` page on the dashboard for failure details.
         * @param {GroundCancelFulfillScheduleRequest} groundCancelFulfillScheduleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SelfserveGroundCancelFulfillSchedulePost(groundCancelFulfillScheduleRequest: GroundCancelFulfillScheduleRequest, options?: RawAxiosRequestConfig): AxiosPromise<GroundCancelFulfillScheduleResponse> {
            return localVarFp.apiV1SelfserveGroundCancelFulfillSchedulePost(groundCancelFulfillScheduleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Poll the status of an existing Ground Cancel quote request. Idempotent request. Investigate `/oklahomaOrder` page on the dashboard for failure details.
         * @param {GroundCancelQuotePollRequest} groundCancelQuotePollRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SelfserveGroundCancelQuotePollPut(groundCancelQuotePollRequest: GroundCancelQuotePollRequest, options?: RawAxiosRequestConfig): AxiosPromise<GroundCancelQuotePollResponse> {
            return localVarFp.apiV1SelfserveGroundCancelQuotePollPut(groundCancelQuotePollRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Start a Ground Cancel Quote, in initiate a cancel quote and retrieving quoteId needed for Cancel Fulfillment. Idempotent request. Investigate `/oklahomaOrder` page on the dashboard for failure details.
         * @param {GroundCancelQuoteScheduleRequest} groundCancelQuoteScheduleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SelfserveGroundCancelQuoteSchedulePost(groundCancelQuoteScheduleRequest: GroundCancelQuoteScheduleRequest, options?: RawAxiosRequestConfig): AxiosPromise<GroundCancelQuoteScheduleResponse> {
            return localVarFp.apiV1SelfserveGroundCancelQuoteSchedulePost(groundCancelQuoteScheduleRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * Autocomplete a ground location, name, or coordinates
     * @param {GroundQuery} groundQuery 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV1AutocompleteGroundPost(groundQuery: GroundQuery, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV1AutocompleteGroundPost(groundQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Ground availability search
     * @param {AvailabilityRequest} availabilityRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV1GroundAvailabilityPost(availabilityRequest: AvailabilityRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV1GroundAvailabilityPost(availabilityRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Itineraries for ground service
     * @param {ItinerariesRequest} itinerariesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV1GroundItinerariesPut(itinerariesRequest: ItinerariesRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV1GroundItinerariesPut(itinerariesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Single itinerary for ground service
     * @param {SingleItineraryRequest} singleItineraryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV1GroundItinerariesSinglePut(singleItineraryRequest: SingleItineraryRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV1GroundItinerariesSinglePut(singleItineraryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Shop for ground service
     * @param {ShopRequest} shopRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV1GroundShopPost(shopRequest: ShopRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV1GroundShopPost(shopRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Poll the status of an existing Ground Cancel Fulfillment request. Idempotent request. Investigate `/oklahomaOrder` page on the dashboard for failure details.
     * @param {GroundCancelFulfillPollRequest} groundCancelFulfillPollRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV1SelfserveGroundCancelFulfillPollPut(groundCancelFulfillPollRequest: GroundCancelFulfillPollRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV1SelfserveGroundCancelFulfillPollPut(groundCancelFulfillPollRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Start a Ground Cancel Fulfillment using the quoteId from a Cancel Quote. Not an idempotent request, as a quoteId can only be fulfilled once, but subsequent calls with the same quoteId will fail rather than do something like over-refund. Investigate `/oklahomaOrder` page on the dashboard for failure details.
     * @param {GroundCancelFulfillScheduleRequest} groundCancelFulfillScheduleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV1SelfserveGroundCancelFulfillSchedulePost(groundCancelFulfillScheduleRequest: GroundCancelFulfillScheduleRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV1SelfserveGroundCancelFulfillSchedulePost(groundCancelFulfillScheduleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Poll the status of an existing Ground Cancel quote request. Idempotent request. Investigate `/oklahomaOrder` page on the dashboard for failure details.
     * @param {GroundCancelQuotePollRequest} groundCancelQuotePollRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV1SelfserveGroundCancelQuotePollPut(groundCancelQuotePollRequest: GroundCancelQuotePollRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV1SelfserveGroundCancelQuotePollPut(groundCancelQuotePollRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Start a Ground Cancel Quote, in initiate a cancel quote and retrieving quoteId needed for Cancel Fulfillment. Idempotent request. Investigate `/oklahomaOrder` page on the dashboard for failure details.
     * @param {GroundCancelQuoteScheduleRequest} groundCancelQuoteScheduleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV1SelfserveGroundCancelQuoteSchedulePost(groundCancelQuoteScheduleRequest: GroundCancelQuoteScheduleRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV1SelfserveGroundCancelQuoteSchedulePost(groundCancelQuoteScheduleRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



